import useMarkdownFile from '@/shared/hooks/useMarkdownFile'
import Markdown from 'react-markdown'

export default function MarkdownPage({ fileUrl }: { fileUrl: string }) {
  const content = useMarkdownFile(fileUrl)
  const isLoading = !content

  if (isLoading) {
    return <div />
  }

  return (
    <div className="m-20 markdown">
      <Markdown>{content}</Markdown>
    </div>
  )
}
